export default {"src":"/_next/static/media/pdf_24.c8c503e9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};